

// Api
import api from '@/api/baseApi';
import masterDataApi from '@/api/masterDataApi';

// Constant
import { SETTINGS_RENTAL_API, SETTINGS_RENTAL_NEWS_API } from "@/constant/apiSettings";
import { SERVICE_TYPE, MACHINE_LIST_FILTER_BY } from '@/constant/rental';
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import base from '@/scripts/base';

// Component
import MachineList from "@/views/component/Dashboard/MachineList";
import DashboardImageThreshold from "@/views/component/Dashboard/DashboardImageThreshold";
import DashboardStorageThreshold from "@/views/component/Dashboard/DashboardStorageThreshold";
import Countdown from "@/components/Countdown";
// Function 
const queryString = require('query-string');



import authApi from "@/api/auth";
import { mapState } from "vuex";
import { GPURENTAL_STATUS_CODE } from "@/constant/config";
import moment from 'moment';
import { Decimal } from 'decimal.js';
import EventBus from "@/event/EventBus";

import { Chart } from 'highcharts-vue'
import { balanceChartOption } from "./balanceChartOption";
// Component
import DashboardServerAvailabilityItem from "@/views/component/Package/DashboardServerAvailabilityItem";

export default {

    extends: base,

    components: {
        highcharts: Chart,
        Countdown,
        DashboardServerAvailabilityItem,

        DashboardImageThreshold,
        DashboardStorageThreshold,

        MachineList,
    },

    computed: {
        ...mapState({
            user: state => state.auth.user,
            tempBalance: state => state.auth.tempBalance,
            gpuHubServicePack: state => state.common.gpuHubServicePack,
            cpuHubServicePack: state => state.common.cpuHubServicePack,
            remoteFarmServicePack: state => state.common.remoteFarmServicePack,
            availabilityServiceList: state => state.common.availabilityServiceList,
            serverReport: state => state.common.serverReport,
            cashbackHighlight: state => state.common.cashbackHighlight,
        }),

        cpuItems() {
            return this.serverReport.filter((x) => x.serviceType === 3 && x.showInUserList);
        },
        gpuSingleCardItems() {
            return this.serverReport.filter((x) => x.serviceType === 1 && x.numberCard === 1 && x.showInUserList);
        },
        gpuMultiCardItems() {
            return this.serverReport.filter((x) => x.serviceType === 1 && x.numberCard > 1 && x.showInUserList);
        },
        chartOptions() {
            return {
                ...balanceChartOption,
                series: [{
                    name: 'Balance',
                    colorByPoint: true,
                    data: [
                        { name: 'Main balance', y: this.user?.balance || 0, color: '#19B5FE' },
                        { name: 'Bonus point', y: this.user?.extraBalanceRental - this.user?.totalCashbackBalance || 0, color: '#529421' },
                        { name: 'Credit back', y: this.user?.totalCashbackBalance || 0, color: '#94D45C' },
                        { name: 'Stake point', y: this.user?.stakingBalance || 0, color: '#C1F069' }
                    ]
                }]
            };
        }
    },

    data() {
        return {
            percentImage: 0,
            percentStorage: 0,
            percentCharged: 0,

            machineList: [],
            machineListRequest: {
                serviceType: SERVICE_TYPE.ALL,
                filterBy: MACHINE_LIST_FILTER_BY.ALL,
                orderBy: 'A.CREATED_AT',
                directionSort: 'DESC',
            },

            delayLoadingComponent: 500,
            isLoadingUserInformation: false,
            isLoadingChart: false,
            isLoadingAvailability: false,
            listImageGpuHubService: [],
            listImageCpuHubService: [],
            listImageRemoteFarmService: [],
            chartMixValue: [],
            chartPieValue: [],
            listDate: [],
            filterChartData: [
                {
                    value: 7,
                    label: 'Last 7 days'
                },
                {
                    value: 15,
                    label: 'Last 15 days'
                },
                {
                    value: 30,
                    label: 'Last 30 days'
                },
                {
                    value: 60,
                    label: 'Last 60 days'
                },
            ],
            chartRequest: 30,
            subTitleChart: '- -\xa0/\xa0- -\xa0/\xa0- - - -\xa0\xa0\xa0-\xa0\xa0\xa0- -\xa0/\xa0- -\xa0/\xa0- - - -',
            currentDataMachine: [],
            currentDataBilling: [],
            timeUsedList: [],
            spentList: [],
            timeUsedGroupByPack: [],
            spentGroupByPack: [],
            totalTimeUsed: 0,
            totalSpent: 0,
            rentalNews: [],
            banners: {},
        }
    },

    mounted() {
        setInterval(() => {
            this.autoRefresh();
        }, 60000);
        this.machineListView();
        this.getAvailabilityService();
        this.getRentalNews();
        this.getBanners();
        EventBus.$emit("openPopup", { type: 'promotion' });
        window.addEventListener('resize', () => {
            this.$refs.hc.chart.reflow()
        })
    },

    methods: {
        getBanners() {
            masterDataApi.getPromotionBannerView()
                .then((res) => {
                    this.banners = res.data.data;
                })
                .catch(error => {
                    console.error(error)
                });
        },
        //#region Set default value machine list
        setDefaultValueMachineList() {
            this.machineList.forEach(element => {
                this.$set(element, 'isSelected', false);
                // var startTimeDuration = moment.utc() - moment.utc((element.startTimeProcessing !== null ? element.startTimeProcessing : element.createdAt));
                // var percentCreating = (moment.duration(startTimeDuration).asSeconds() / this.timeForCreatingImage);
                // if (element.isCreating || element.isStarting) {
                //     if (percentCreating < 0.99) {
                //         element.percentLoad = percentCreating >= 0 ? percentCreating * 100 : 0;
                //     }
                //     else {
                //         element.percentLoad = 99;
                //     }
                // }
                // element.estimatedTotal = Math.round(((element.uptime * element.priceHour) / (60 * 60) + 0.00001) * 1000) / 1000;
                // if (element.uptime !== 0) {
                //     element.duration = this.caclDuration(element.uptime);
                // } else {
                //     element.duration = '0m';
                // }
            });
        },
        //#endregion

        //#region Machine list view
        machineListView() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            api.baseRequest(SETTINGS_RENTAL_API.MACHINE_LIST_VIEW, null, `?${queryString.stringify(this.machineListRequest)}`)
                .then((res) => {
                    this.machineList = res.data;
                    this.setDefaultValueMachineList();
                    // this.selectionDefaultImage();
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, "Request failed ...")
                });
        },
        //#endregion

        // Refresh component
        refreshComponent(component) {
            switch (component) {
                case 'userInformation':
                    this.machineListView();
                    //this.$store.dispatch("auth/getUserInfo");
                    this.$store.dispatch("auth/getTempBalance");
                    break;
                case 'chart':
                    this.getInformationBilling();
                    break;
                case 'availability':
                    this.getAvailabilityService();
                    break;
            }
        },

        // Filter chart
        filterChart() {
            this.getInformationBilling();
        },

        // Auto refresh component
        autoRefresh() {
            this.machineListView();
            this.getRentalNews();
            // this.refreshInformationBilling();
        },

        // Refresh information machine
        refreshInformationMachine() {
            authApi.getDashboardInformationMachine()
                .then(res => {
                    try {
                        switch (res.errorCode) {
                            case GPURENTAL_STATUS_CODE.DashboardGetInformationMachine_Success:
                                if (!this.arraysAreEqual(this.currentDataMachine, res.data)) {
                                    this.postGetInformationMachineSuccess(res.data);
                                }
                                break;
                        }
                    } catch (error) { console.error(error) }
                }).catch(error => this.proccessError(error));
        },

        // Refresh information billing
        refreshInformationBilling() {
            authApi.getDashboardInformationBilling(this.chartRequest)
                .then(res => {
                    try {
                        switch (res.errorCode) {
                            case GPURENTAL_STATUS_CODE.DashboardGetInformationBilling_Success:
                                if (!this.arraysAreEqual(this.currentDataBilling, res.data)) {
                                    this.postGetInformationMachineBilling(res.data);
                                }
                                break;
                        }
                    } catch (error) { console.error(error) }
                }).catch(error => this.proccessError(error));
        },

        // Get range chart
        getRangeChart() {
            this.listDate = [];
            this.chartMixValue = [];
            this.chartPieValue = [];
            for (let i = (this.chartRequest - 1); i >= 0; i--) {
                let current = moment.utc(moment().subtract(i, 'days')).local().format('MMM DD YYYY')
                this.listDate.push(current);
                this.chartMixValue.push({
                    name: current,
                    timeUsed: 0,
                    spent: 0,
                });
            }
            this.subTitleChart = `${this.listDate[0]}\xa0\xa0-\xa0\xa0${this.listDate[this.listDate.length - 1]}`;

            let servicePack = this.gpuHubServicePack.concat(this.remoteFarmServicePack);
            servicePack.forEach(element => {
                this.chartPieValue.push({
                    id: element.id,
                    name: element.name,
                    timeUsed: 0,
                    spent: 0,
                });
            });
        },

        // Get information machine
        getInformationMachine() {
            this.preGetInformationMachine();
            authApi.getDashboardInformationMachine()
                .then(res => {
                    setTimeout(() => {
                        try {
                            switch (res.errorCode) {
                                case GPURENTAL_STATUS_CODE.DashboardGetInformationMachine_Success:
                                    this.postGetInformationMachineSuccess(res.data);
                                    break;
                                default:
                                    this.$store.dispatch("common/showUnkownError", res, this.$lang.dialog.forgotPasswordFailed);
                                    break;
                            }
                        } catch (error) {
                            this.$store.dispatch("common/showUnkownError", error, this.$lang.dialog.forgotPasswordFailed);
                        }
                    }, this.delayLoadingComponent);
                }).catch(error => this.proccessError(error));
        },

        // Get information billing
        getInformationBilling() {
            this.preGetInformationBilling();
            authApi.getDashboardInformationBilling(this.chartRequest)
                .then(res => {
                    setTimeout(() => {
                        try {
                            switch (res.errorCode) {
                                case GPURENTAL_STATUS_CODE.DashboardGetInformationBilling_Success:
                                    this.postGetInformationMachineBilling(res.data);
                                    break;
                                default:
                                    this.$store.dispatch("common/showUnkownError", res, this.$lang.dialog.forgotPasswordFailed);
                                    break;
                            }
                        } catch (error) {
                            this.$store.dispatch("common/showUnkownError", error, this.$lang.dialog.forgotPasswordFailed);
                        }
                    }, this.delayLoadingComponent);
                }).catch(error => this.proccessError(error));
        },

        // Get availability service
        getAvailabilityService() {
            this.isLoadingAvailability = true;
            setTimeout(() => {
                this.isLoadingAvailability = false;
            }, 1000);
        },
        getRentalNews() {
            api.baseRequest(SETTINGS_RENTAL_NEWS_API.GET_ACTIVE_NEWS)
                .then((res) => {
                    if (res.result === 0) {
                        if (res.data !== null) {
                            this.rentalNews = res.data;
                        }
                    }
                })
                .catch(error => {
                    console.error(error)
                });
        },
        // Equal 2 array
        arraysAreEqual(ary1, ary2) {
            return (ary1.join('') == ary2.join(''));
        },

        // Proccess error
        proccessError(error) {
            if (error.name === 'Error') {
                if (this.$route.path !== '/login') {
                    setTimeout(() => {

                    }, 2000);
                }
            } else { console.error(error) }
        },

        // Pre get information machine
        preGetInformationMachine() {
            this.isLoadingUserInformation = true;
        },

        // Post get information machine success
        postGetInformationMachineSuccess(data) {
            this.currentDataMachine = data;
            this.listImageGpuHubService = [];
            this.listImageRemoteFarmService = [];
            this.listImageCpuHubService = [];
            data.forEach(element => {
                element.statusText = this.getStatusText(element.status);
                // element.estimatedTotal = Math.round(((element.uptime * element.rentalServicePack.pricing) / (60 * 60) + 0.00001) * 1000) / 1000;
                // if (element.uptime !== 0) {
                //     element.duration = this.caclDuration(element.uptime);
                // } else {
                //     element.duration = '0m';
                // }
                switch (element.rentalServicePack.serviceType) {
                    case 1:
                        this.listImageGpuHubService.push(element);
                        break;
                    case 2:
                        this.listImageRemoteFarmService.push(element);
                        break;
                    case 3:
                        this.listImageCpuHubService.push(element);
                        break;
                }
            });

            setTimeout(() => {
                this.isLoadingUserInformation = false;
            }, this.delayLoadingComponent);
        },

        // Pre get information billing
        preGetInformationBilling() {
            this.isLoadingChart = true;
        },

        // Post get information billing success
        postGetInformationMachineBilling(data) {
            this.currentDataBilling = data;
            this.getRangeChart();
            let listBilling = [];
            this.totalSpent = 0;
            this.totalTimeUsed = 0;
            data.forEach(element => {
                var date = moment(moment.utc(element.transAt).local().format('YYYY-MM-DD HH:mm:ss')).format('MMM DD YYYY');
                if (this.listDate.includes(date)) {
                    listBilling.push(element);
                    let targetMixItem = this.chartMixValue.find(item => item.name === date);
                    let targetPieItem = this.chartPieValue.find(item => item.id === element.packageName);
                    let z = new Decimal(element.transCharged);

                    if (targetMixItem !== undefined && targetMixItem !== null) {
                        targetMixItem.timeUsed += element.upTime;
                        let x = new Decimal(targetMixItem.spent);
                        targetMixItem.spent = parseFloat(x.plus(z));
                    }

                    if (targetPieItem !== undefined && targetPieItem !== null) {
                        targetPieItem.timeUsed += element.upTime;
                        let y = new Decimal(targetPieItem.spent);
                        targetPieItem.spent = parseFloat(y.plus(z));
                    }

                    this.totalSpent += element.transCharged;
                    this.totalTimeUsed += element.upTime;
                }
            });

            this.timeUsedList = this.chartMixValue.map(x => parseFloat(((x.timeUsed) / (60 * 60)).toFixed(2)));
            this.spentList = this.chartMixValue.map(x => x.spent);

            this.spentGroupByPack = [];
            this.timeUsedGroupByPack = [];

            for (let index = 0; index < this.chartPieValue.length; index++) {
                let backgroundColor = '';
                if (this.gpuHubColor.find(item => item.id === this.chartPieValue[index].id)) {
                    backgroundColor = this.gpuHubColor.find(item => item.id === this.chartPieValue[index].id).color
                }
                this.spentGroupByPack.push({
                    text: this.chartPieValue[index].name,
                    values: [this.chartPieValue[index].spent],
                    backgroundColor: backgroundColor,
                    borderWidth: '1px',
                });
                this.timeUsedGroupByPack.push({
                    values: [parseFloat((this.chartPieValue[index].timeUsed / (60 * 60)).toFixed(2))],
                    backgroundColor: backgroundColor,
                    borderWidth: '1px',
                });
            }

            this.totalSpent = `<span style='font-size:25px;'>${this.totalSpent.toFixed(4)}</span><br>iRender Point (iRp)`;
            this.totalTimeUsed = `<span style='font-size:25px;'>${parseFloat((this.totalTimeUsed / (60 * 60)).toFixed(2))}</span><br>Hours (h)`;

            setTimeout(() => {
                this.isLoadingChart = false;
            }, 500);
        },

        // Open pop-up
        openPopup(popup, value) {
            this.$emit("openPopup", popup, value);
        },
    }
}